/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UpdateWhiteListCarDto { 
    id?: number;
    employeeName: string;
    phoneNumber: string;
    vehicleRegistrationNo: string;
    state_Province: string;
    isActive: boolean;
}

